import AccountDetails from 'Agent/Accounts/components/AccountDetails';
import AccountDiscrepancies from 'Agent/Accounts/components/AccountDiscrepancies';
import AccountDiscrepancySummaries from 'Agent/Accounts/components/AccountDiscrepancySummaries';
import Accounts from 'Agent/Accounts/components/Accounts';
import React from 'react';
import {Route, RouteComponentProps, Switch} from 'react-router';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import PolicyInformationReport from './components/PolicyInformationReport';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import {useDispatch} from 'react-redux';
import {changeAccountFilters, EmptyAccountFilter} from 'Agent/Accounts/ducks/account';
import AccountRouteConstants from 'Agent/Accounts/AccountRouteConstants';
import useOnNavigateAway from 'Shared/utilities/useOnNavigateAway';
import InvoiceDiscrepancies from './components/InvoiceDiscrepancies';

type AgentRoutesProps = {
  selectedAgency: AgencyFilters;
} & RouteComponentProps;

const AgentRoutes = ({match, selectedAgency}: AgentRoutesProps) => {
  useBreadcrumbs('Accounts', match.url);
  const dispatch = useDispatch();
  const clearAccountFilters = () => dispatch(changeAccountFilters(EmptyAccountFilter));

  useOnNavigateAway(AccountRouteConstants.ACCOUNTS, clearAccountFilters);
  
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}/:accountId/discrepancySummaries`}
        render={() => <AccountDiscrepancySummaries selectedAgency={selectedAgency} />}
      />
      <Route
        exact
        path={`${match.url}/:accountNumber/discrepancies/:accountId`}
        // @ts-ignore
        render={routeProps => <AccountDiscrepancies {...routeProps} />}
      />
      <Route
        exact
        path={`${match.url}/:accountId/accountNumber/:accountNumber`}  
        // @ts-ignore
        render={routeProps => <AccountDetails {...routeProps} selectedAgency={selectedAgency} />}
      />
      <Route
        exact
        path={`${match.url}`}
        render={routeProps => <Accounts {...routeProps} selectedAgency={selectedAgency} />}
      /> 
     
      <Route 
        exact 
        path={`${match.url}/:accountNumber/invoice/:invoiceId/:revision/:uuid/`} 
        // @ts-ignore
        render={(routeProps) => <InvoiceDiscrepancies {...routeProps}/>} />
    </Switch>
  );
};

export default ({selectedAgency, ...props}: AgentRoutesProps) => {
  return (
    <Route
      path={`${props.match.url}/accounts`}
      render={routeProps => (
        <Switch>
          <Route
            path={`${routeProps.match.url}/reports/policyInformationReport`}
            render={() => <PolicyInformationReport selectedAgency={selectedAgency} />}
            exact
          />
          <AgentRoutes {...routeProps} selectedAgency={selectedAgency} />
        </Switch>
      )}
    />
  );
};
